import Button from 'react-bootstrap/Button';
import { FaPlus, FaMinus } from "react-icons/fa6";
import DataGrid from "../../components/DataGrid";
import OverflowText from '../../components/ui/OverflowTooltip';
import GridButton from '../../components/ui/GridButton';
import Icon from '../../components/ui/Icon';
import { COHORT_TRAINING_FLAG } from '../../constants';
import { toDateTime } from '../../utils/utils';
import React from 'react';

const NestedCohortTable = () => {

    const data = [
        {
            "id": 132,
            "companyId": -1,
            "userId": -3,
            "fileName": "ManualImport.csv",
            "name": "Manual Cohort",
            "status": "Validated",
            "training": "Y",
            "memberCount": 125,
            "retentionRiskStatus": null,
            "retentionRiskStatusDateTime": null,
            "retentionRiskMonitoringStatus": null,
            "retentionRiskMonitoringStatusDateTime": null,
            "marketType": "Single",
            "market": "AL",
            "dateTime": "2024-05-24T08:31:51.000Z",
            "cohortUpdateCount": 1,
            "subRows": [
                /*{
                    "id": 1320,
                    "fileName": "Member List",
                    "name": "Update name",
                    "status": "In Process",
                    "memberCount": "Member Count",
                    "dateTime": "Update time",
                },*/
                {
                    "id": 1320,
                    "companyId": -1,
                    "userId": -3,
                    "fileName": "ManualImport-v2.csv",
                    "name": "Members Jan 2025",
                    "status": "In Process",
                    "memberCount": 15,
                    "dateTime": "2025-01-24T08:31:51.000Z",
                    "cohortUpdateCount": 0,
                },
                {
                    "id": 1321,
                    "companyId": -1,
                    "userId": -3,
                    "fileName": "ManualImport-v3.csv",
                    "name": "Members Feb 2025",
                    "status": "Processed",
                    "memberCount": 25,
                    "dateTime": "2025-02-10T08:31:51.000Z",
                    "cohortUpdateCount": 0,
                }
            ]
        },
        {
            "id": 133,
            "companyId": -1,
            "userId": -3,
            "fileName": "SampleCohortList2.csv",
            "name": "TestCohortValue",
            "status": "Validated",
            "training": "Y",
            "memberCount": 5308,
            "retentionRiskStatus": null,
            "retentionRiskStatusDateTime": null,
            "retentionRiskMonitoringStatus": null,
            "retentionRiskMonitoringStatusDateTime": null,
            "marketType": "Single",
            "market": "AL",
            "dateTime": "2024-04-20T08:31:51.000Z",
            "cohortUpdateCount": 0,
            "subRows": [
                {
                    "id": 1322,
                    "companyId": -1,
                    "userId": -3,
                    "fileName": "SampleCohortList2-v2.csv",
                    "name": "Manual update 2",
                    "status": "In Process",
                    "memberCount": 12,
                    "dateTime": "2025-01-14T08:31:51.000Z",
                    "cohortUpdateCount": 0,
                }
            ]
        },
        {
            "id": 134,
            "companyId": -1,
            "userId": -3,
            "fileName": "SampleCohortList4.csv",
            "name": "TestCohortValue",
            "status": "Validated",
            "training": "Y",
            "memberCount": 5308,
            "retentionRiskStatus": null,
            "retentionRiskStatusDateTime": null,
            "retentionRiskMonitoringStatus": null,
            "retentionRiskMonitoringStatusDateTime": null,
            "marketType": "Single",
            "market": "AL",
            "dateTime": "2024-03-12T08:31:51.000Z",
            "cohortUpdateCount": 0
        }
    ];

    const renderRowActions = () => {
        return (
            <>
                <GridButton variant="light" size="sm" className="me-1 py-0" title="View">
                    <Icon icon="view" size={14} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 py-0" title="Results">
                    <Icon icon="results" size={16} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 py-0" title="Archive">
                    <Icon icon="archive" size={16} />
                </GridButton>
            </>
        )
    }

    const renderAggregateRowActions = () => {
        return (
            <>
                <GridButton variant="light" size="sm" className="me-1 my-1" title="Update">
                    <Icon icon="update-cohort" size={14} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 my-1" title="Edit">
                    <Icon icon="edit" size={14} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 my-1" title="Merge">
                    <Icon icon="merge" size={14} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 my-1" title="Schedule">
                    <Icon icon="schedule" size={16} />
                </GridButton>
                <GridButton variant="light" size="sm" className="me-1 my-1" title="Archive">
                    <Icon icon="archive" size={16} />
                </GridButton>
            </>
        )
    }

    const columns = [
        {
            id: 'expand',
            size: 32,
            minSize: 32,
            aggregatedCell: ({ row }) => {
                return (
                    <Button
                        size="sm"
                        variant="light"
                        onClick={row.getToggleExpandedHandler()}
                        style={{ cursor: 'pointer' }}>
                        {row.getIsExpanded() ? <FaMinus /> : <FaPlus />}
                    </Button>
                );
            },
        },
        {
            id: 'name',
            header: 'Cohort Name',
            accessorKey: 'name',
            maxSize: 400,
            aggregatedCell: ({ row }) => (row.original.name),
            cell: ({ row, getValue }) => {
                return (
                    <div style={{ paddingLeft: `${row.depth * 1}rem` }}>
                        {getValue()}
                    </div>
                );
            },
        },
        {
            id: 'status',
            header: 'Cohort status',
            accessorKey: 'status',
            aggregatedCell: ({ row }) => <div className="text-decoration-underline text-secondary cursor-pointer">{row.original.status}</div>,
            cell: ({ row }) => row.depth === 0 ? <div className="text-decoration-underline text-secondary cursor-pointer">{row.original.status}</div> : row.original.status,
            sortingFn: 'text',
        },
        {
            id: 'fileName',
            header: 'Member List',
            accessorKey: 'fileName',
            sortingFn: 'text',
            cell: ({ row, cell }) => (
                <OverflowText id={cell.id}>
                    {row.original.fileName}
                </OverflowText>
            ),
        },
        {
            id: 'memberCount',
            header: 'Member Count',
            accessorKey: 'memberCount',
            size: 80,
        },
        {
            id: 'dateTime',
            header: 'Last Upload DateTime',
            accessorKey: 'dateTime',
            sortType: 'date',
            accessorFn: (row) => new Date(row.dateTime),
            cell: ({ row }) => `${toDateTime(row.original.dateTime)}`,
            aggregatedCell: ({ row }) => `${toDateTime(row.original.dateTime)}`,
            sortingFn: 'datetime',
            size: 150,
        },
        {
            id: 'training',
            header: 'Training Cohort',
            accessorKey: 'training',
            size: 120,
            cell: ({ row }) => (
                <div>{COHORT_TRAINING_FLAG[row.original.training]}</div>
            ),
            aggregatedCell: ({ row }) => (
                <div>{COHORT_TRAINING_FLAG[row.original.training]}</div>
            ),
            sortingFn: 'text',
        },
        {
            id: 'marketType',
            header: 'Market Type',
            accessorKey: 'marketType',
            size: 80,
        },
        {
            id: 'market',
            header: 'Market',
            accessorKey: 'market',
            size: 80,
        },
        {
            name: 'actions',
            header: 'Actions',
            size: 170,
            cell: ({ row }) => (
                <div className="text-end">
                    {row.depth === 0 ? renderAggregateRowActions() : renderRowActions()}
                </div>
            ),
            aggregatedCell: () => (
                <div className="text-end">
                    {renderAggregateRowActions()}
                </div>
            )
        },
    ];

    const renderRowHeaderComponent = (row) => {
        return (
            <tr key={row.id + 'expanded'}>
                <td/>
                <td className="bg-secondary text-white">Update Name</td>
                <td className="bg-secondary text-white" colSpan={2}>Status</td>
                {/*<td className="bg-secondary text-white"></td>*/}
                <td className="bg-secondary text-white">Member List</td>
                <td className="bg-secondary text-white" colSpan={3}>Member Count</td>
                {/*<td className="bg-secondary text-white"></td>
                <td className="bg-secondary text-white"></td>*/}
                <td className="bg-secondary text-white">Updated DateTime</td>
                <td className="bg-secondary text-white"/>
            </tr>
        )
    }

    return (
        <DataGrid
            columns={columns}
            data={data}
            enableFilters={false}
            enableNesting={true}
            // rowSubComponent={renderRowSubComponent}
            rowSubHeaderComponent={renderRowHeaderComponent}
        />
    );
}

export default NestedCohortTable
